module.exports = __webpack_public_path__ + "static/media/exchange-plus-ecosystem.a1cea6e3.png";